export default __webpack_public_path__ + "static/media/email-white-18dp.17fa3c5f.svg";